import React, { useContext } from "react";
import LinkCard from "../layout/LinkCard";
import Header from "../layout/Header";
import MainContainer from "../layout/MainContainer";
import usePermissions from "../../hooks/usePermissions";
import { Typography } from "@mui/material";
import { AuthContext } from "../../services/Authentication";

// Utility function to get the first and last day of the previous month
const getDateRange = () => {
  const today = new Date();
  const prevMonth = today.getMonth() - 1;
  const firstDay = 1;
  const lastDay = 0;
  const startDate = new Date(
    today.getFullYear(),
    prevMonth,
    firstDay
  ).toLocaleDateString();
  const endDate = new Date(
    today.getFullYear(),
    today.getMonth(),
    lastDay
  ).toLocaleDateString();

  return { startDate, endDate };
};

const Dashboard = (props) => {
  const permissions = usePermissions();
  const { state: authState } = useContext(AuthContext);

  const canViewAnyReports = permissions.canViewAnyItems;
  const header = "Reports";

  const getCommissionURL = () => {
    const { startDate, endDate } = getDateRange();
    const params = { startdate: startDate, enddate: endDate };
    return `/commission/?${new URLSearchParams(params).toString()}`;
  };

  const getCommissionTreeCommissionURL = () => {
    const { startDate, endDate } = getDateRange();
    const params = { startdate: startDate, enddate: endDate };
    return `/commissiontree/?${new URLSearchParams(params).toString()}`;
  };

  const getCallCenterCommissionURL = () => {
    const { startDate, endDate } = getDateRange();
    const params = { startdate: startDate, enddate: endDate };
    return `/callcentercommission/?${new URLSearchParams(params).toString()}`;
  };

  const getESSCommissionURL = () => {
    const { startDate, endDate } = getDateRange();
    const params = { startdate: startDate, enddate: endDate };
    return `/esscommission/?${new URLSearchParams(params).toString()}`;
  };

  const getPortablesCommissionURL = () => {
    const { startDate, endDate } = getDateRange();
    const params = { startdate: startDate, enddate: endDate };
    return `/portablescommission/?${new URLSearchParams(params).toString()}`;
  };

  const commissionURL = getCommissionURL();
  const commissionTreeCommissionURL = getCommissionTreeCommissionURL();
  const callCenterCommissionURL = getCallCenterCommissionURL();
  const essCommissionURL = getESSCommissionURL();
  const portablesCommissionURL = getPortablesCommissionURL();

  window.document.title = `${header} | Suite Sales`;

  return (
    <>
      <Header header={header} />
      <MainContainer className="flex flex-row flex-wrap py-10 justify-center space-x-10">
        {!canViewAnyReports && (
          <Typography>You do not have access to any reports</Typography>
        )}
        {permissions.canViewAnyItems && (
          <LinkCard
            url={`/inventory/?location=${authState.user.default_location}`}
            title={"Inventory"}
            titleProps={{ variant: "h5", className: "my-2" }}
            bodyProps={{ variant: "body2", color: "text.secondary" }}
            img={"/img/inventory.jpg"}
            imgAlt={"man counting inventory"}
            body={"Quantities of available and backordered inventory"}
          />
        )}
        {permissions.canViewAnyCommission && (
          <LinkCard
            url={commissionURL}
            title={"Commission"}
            titleProps={{ variant: "h5", className: "my-2" }}
            bodyProps={{ variant: "body2", color: "text.secondary" }}
            img={"/img/commission.jpg"}
            imgAlt={"hand with money"}
            body={"Pending and earned commission"}
          />
        )}
        {permissions.canViewAnyCommission && (
          <LinkCard
            url={commissionTreeCommissionURL}
            title={"Commission Tree"}
            titleProps={{ variant: "h5", className: "my-2" }}
            bodyProps={{ variant: "body2", color: "text.secondary" }}
            img={"/img/callcenter-commission.jpg"}
            imgAlt={"hand with money"}
            body={"Pending and earned commission"}
          />
        )}
        {permissions.isAdmin && (
          <LinkCard
            url={callCenterCommissionURL}
            title={"Call Center Commission"}
            titleProps={{ variant: "h5", className: "my-2" }}
            bodyProps={{ variant: "body2", color: "text.secondary" }}
            img={"/img/callcenter-commission.jpg"}
            imgAlt={"hand with money"}
            body={"Pending and earned commission"}
          />
        )}
        {permissions.canViewAnyCommission && (
          <LinkCard
            url={essCommissionURL}
            title={"ESS Commission"}
            titleProps={{ variant: "h5", className: "my-2" }}
            bodyProps={{ variant: "body2", color: "text.secondary" }}
            img={"/img/callcenter-commission.jpg"}
            imgAlt={"chart showing ESS commission"}
            body={"Pending and earned ESS commission"}
          />
        )}
        {permissions.canViewAnyCommission && (
          <LinkCard
            url={portablesCommissionURL}
            title={"Portables Commission"}
            titleProps={{ variant: "h5", className: "my-2" }}
            bodyProps={{ variant: "body2", color: "text.secondary" }}
            img={"/img/callcenter-commission.jpg"}
            imgAlt={"chart showing Portables commission"}
            body={"Pending and earned Portables commission"}
          />
        )}
      </MainContainer>
    </>
  );
};

export default Dashboard;
